'use client'

import Logo from 'app/components/atoms/Logo'
import { Layout } from 'app/components/layouts'

interface LayoutProps {
  children?: React.ReactNode
}

const SimpleLayout: React.FunctionComponent<LayoutProps> = ({ children }) => {
  return (
    <Layout>
      <div className="absolute top-12 lg:top-15 left-8 lg:left-15 z-[500]">
        <Logo />
      </div>
      <div className="flex justify-center px-8">{children}</div>
    </Layout>
  )
}

export default SimpleLayout
